import { render, staticRenderFns } from "./WageAverageLineChart.vue?vue&type=template&id=141717a8&scoped=true&"
import script from "./WageAverageLineChart.vue?vue&type=script&lang=js&"
export * from "./WageAverageLineChart.vue?vue&type=script&lang=js&"
import style0 from "./WageAverageLineChart.vue?vue&type=style&index=0&id=141717a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141717a8",
  null
  
)

export default component.exports